export default __webpack_public_path__ + "static/media/woman-chair-graphic.5f566f02.png";